<div class="header">
  <div class="content-container">
    <div class="textual-content-container">
      <div class="textual-content">
        @if (subtitle) {
          <h2
            class="subheading serif">
            {{ subtitle }}
          </h2>
        }

        <h1 class="text-white">
          {{ title }}
        </h1>

        <div class="description-container">
          @if (description) {
            <p
              class="text-white"
              >
              {{ description  | truncateText: 300 }}
            </p>
          }
        </div>
      </div>

      @if (brandImage) {
        <div
          class="brand"
          >
          <img [src]="brandImage.url"
            alt="{{ title }}"
            [attr.loading]="lazyLoad ? 'lazy' : 'eager'"
            >
        </div>
      }
    </div>

    <div class="image">
      @if (headerImage) {
        <app-responsive-image
          [image]="headerImage"
          [lazyLoad]="lazyLoad"
          class="category-image"
        ></app-responsive-image>
      }
    </div>
  </div>

  <div class="bg-pattern"></div>
</div>
